import { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import React from 'react';
import Disclaimer from "@/app/ui/Disclaimer"
import { getTrackAnalysis, getTrackAnalysisExperts} from '@/app/utils/request/requestList';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';
import { LANGTYPE_EN, useLanguage } from '@/app/utils/LanguageContext';
import { useMyContext } from '@/app/utils/MyContext';
import VideoPlayerIcon from "@/app/ui/Common/SvgComponent/VideoPlayerIcon";
import { ValidVideo, VideoSource } from "@/app/utils/class/common/video";
import { generateVideoSource, generateVideoUrl, validateVideo } from "@/app/utils/Video";
import VideoPlayer from "@/app/ui/Common/VideoPlayer";
import { useMediaQuery } from "@mui/material";
import { generateAdobeDataRaceNo, getSearchParams, setRacesDetailLoading, theme, adobeData } from "@/app/utils/Common";
import NoInformation from "@/app/ui/Common/NoInformation";
import { text_size } from "@/app/utils/MixinSize";
import ExpertProfile from "@/app/ui/Common/ExpertProfile"
import { VideoWAData } from "@/app/ui/Common/VideoPlayer/player";
import { useLoading } from "@/app/utils/LoadingContext";

const DivContainer =  styled('div')<{ $assetPrefix?: string }>(({ $assetPrefix }) => `
    border-radius: 0 0 4px 4px;
    background-image: url(${$assetPrefix}/text_bg.png);
    background-repeat: repeat-y;
`);

const DivContainerM = styled.div`
    background-color: #FFFFFF;
    border-radius: 0 0 4px 4px;
    padding:12px;
    > div + div {
        margin-top: 12px;
    }
`;

const TrackAnalysisHeader = styled.div`
  width: 100%;
  height: 36px;
  padding: 8px 12px;
  ${text_size(15)}
  line-height: 20px;
  font-weight: 500;
  background-color: #E1E1E1;
`;

const DivTrackAnalysiContent = styled.div`
    flex: 1 1 50%;
    min-width: 320px;
    max-width: 50%;
    box-sizing: border-box;
    padding-right: 12px;
`;

const DivTrackAndVideo = styled.div`
    flex: 1 1 50%;
    min-width: 320px;
    max-width: 50%;
    margin: 0;
    box-sizing: border-box;
    padding-left: 12px;
`;

const DivVideo = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;    
    display: flex;
    justify-content: center;
    align-items: center;
    cursor:pointer;
    border-radius: 0px;
`;

const DivVideoM = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 335px;
    width: 100%;
    margin: 0 auto;
    padding: 12px;
`;

const DivVideoPlayIcon = styled.div`
    position: absolute;
    text-align: center;
    vertical-align: text-bottom;

    svg {
        width: 38px;
        height: 38px;
    }
`;

const ImgTrack = styled.img`
    width: 100%;
    display: block;
    margin: 0 auto;
    border-radius: 4px 4px 4px 4px;
`;

const ImgVideo = styled.img`
    width: 100%;
    display: block;
    margin: 0 auto;
    border-radius: 4px 4px 0px 0px;
`;

const DivCourseOverview = styled.div`
    background: #333333;
    border-radius: 0px 0px 4px 4px;
    font-weight: 500;
    ${text_size(15)}
    line-height: 20px;
    max-height: 48px;
    align-items: center;
    color: #FFFFFF;
    padding: 4px 12px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 0px;
`;

const ImgTrackM = styled.img`
    max-width: 256px;
    width: 100%;
    display: block;
    margin: 0 auto;
    border-radius: 4px 4px 4px 4px;
`;
const DivTitle = styled.div`
    ${text_size(13)}
    font-weight: 700;
    line-height: 18px;
    padding-bottom: 4px;
    font-family: "Noto Sans TC" !important;
`;
const DivContent = styled.div`
    ${text_size(13)}
    font-weight: 400;
    line-height: 17px;
`;

const TopContentWrapper = styled.div`
    width: 100%;
    display: flex;
    box-sizing: border-box;
`;
const BottomContentWrapper = styled.div` 
    width: 100%;
    padding: 16px 12px 20px 12px;
    box-sizing: border-box;
`;
const TriangleUpDisclaimer = styled.div<{ $showDisclaimer: Boolean }>
(({ $showDisclaimer}) => `
    width: 0;
    height: 0;
    border-left: 10px solid transparent;   
    border-right: 10px solid transparent;  
    border-top: 10px solid #f4f4f4;    
    position: absolute;
    top: -12px; 
    right: 30px;
    opacity: 1; 
    display: ${$showDisclaimer ? 'block': 'none'};  
`);
const HiddenDisclaimer = styled.div<{ $showDisclaimer: boolean }>
(({ $showDisclaimer}) => `
    display: ${$showDisclaimer ? 'block': 'none'}; 
    opacity: 1;    
    transition: opacity 0.2s ease;  
    position: absolute; 
    left: calc((100px - 507px) / 2);
    padding: 12px;
    border-radius: 4px;
    bottom: 36px;
    width: 507px;
    height: max-content;
    background: #f4f4f4;
    z-index: 161;
    color: #000;
    cursor: text;
    ${text_size(13)}
    
    /* MODIFIED: force disclaimer popup text to lighter weight */
    font-weight: 400;

    /* MODIFIED: override nested Disclaimer text if it has its own font-weight */
    * {
        font-weight: 400;
    }

    a{
      color: #122C68;
    }
    a:hover{
      text-decoration: underline;
    }
`)
const DisclaimerWrapper = styled.div` 
    margin-top:12px;
    padding: 12px 0 0;
    font-weight: 400;    
    ${text_size(11)}
    color: #000000;
    border-top: 1px solid #E1E1E1;
    >div:first-child{
        display: flex;
        align-items: center;
        line-height: 14px;
        >span{
            display: inline-flex;
            align-items: center;
            line-height: 14px;
            padding-left: 8px;
             ${text_size(11)}
            font-weight: 700;
            color: #122C68; 
            cursor: pointer;
        }
        img {
            display: block;
            flex-shrink: 0;
        }
    }
`;
const DisclaimerWrapperM = styled.div` 
    margin-top: 12px;
    padding-top: 16px;
    border-top: 1px solid rgb(180, 180, 180);
    color: #000000;
    font-weight: 400;    
    ${text_size(11)}
    margin: 0;
    padding: 12px 0 0 ; 
    border-top: 1px solid #E1E1E1;    
    p{ 
        display: inline-block;
        ${text_size(11)}
        font-weight: 700;
        margin-top: 6px;
        padding: 2px 0;
        line-height: 16.5px;
        color: #122C68;
        cursor: pointer;
        width: 86px;
        img{
            vertical-align: middle;
            margin-right: 4px;
        }
    }
`;
const TrackAnalysisExpertName = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    padding: 0 0 12px;
`;
const TrackAnalysisExpertNameM = styled.div`
    display: flex;
    align-items: center;
    font-weight: 500;
    ${text_size(15)}
    color: #122C68;
    .pic{ 
        height: 50px;
        margin-right: 12px;
        
        width: 44px;
        height: 44px; 
        overflow: clip;
        img{
            width: 44px;
            height: 44px; 
        }
    }
    .info-icon{
        width: 24px;
        height: 24px;
        margin-left: 8px;

        img{ vertical-align: middle; }
    }
`;
const TrackAnalysisHeaderImg = styled.img`
    width: 44px;
    height: 44px;
`;
const InnerSpan = styled.div`
    padding: 0 8px 0 12px; 
    font-weight: 500;
    ${text_size(15)}
    color: #122C68;
`;

const TriangleUp = styled.div<{ $showText: Boolean }>
(({ $showText}) => `
  width: 0;
  height: 0;
  border-left: 10px solid transparent;   
  border-right: 10px solid transparent;  
  border-bottom: 10px solid #f4f4f4;    
  position: absolute;
    bottom: -18px;
    left: 0;
    opacity: ${$showText ? 1: 0};    
`);
const TipsContainer = styled.div`     
`;

const Hiddentext = styled.div<{ $showText: Boolean }>
(({ $showText}) => `
    display: ${$showText ? 'block': 'none'}; 
    opacity: 1;         
    transition: opacity 0.2s ease;  
    position: absolute; 
    left: 0;
    padding: 5px;
    border-radius: 4px;
    top: 50px;
    width: 507px;
    height: max-content;
    background: #f4f4f4;
    z-index: 99;
    color: #000;
    ${text_size(13)};
`);

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


interface propType {
    setRacesDetailLoading: (loading: boolean) => void;
    type?: string;
}

const TrackAnalysis: React.FC<propType> = (props: propType) => {
    const { completeLoading } = useLoading();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [trackAnalysisData, setTrackAnalysisData] = useState<any>(null);
    const [expertName, setExpertName] = useState<string>('');
    const [isShowVideoPlay, setIsShowVideoPlay] = useState(false);
    const [videoSources, setVideoSources] = useState([] as VideoSource[]);
    const [WAData, setWAData] = useState<VideoWAData | undefined>(undefined);
    const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));

    const [showDisclaimer, setshowDisclaimer] = useState(false); 
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [dialogType, setDialogType] = useState<string>("");
    const [disclaimerData, setDisclaimerData] = React.useState('');
    const TwoASwitch = window.globalConfig?.TwoASwitch;
    const [showText, setshowText] = useState(false);
    const [trackAnalysisExperts, setTrackAnalysisExperts] = useState<any>(null);
    const [expertNameEn, setExpertNameEn] = useState<string>(); 

    useEffect(() => {
        document.addEventListener('click', handleOutSideclick);
        return () => {
            document.removeEventListener('click', handleOutSideclick);
        }
    }, [showDisclaimer]);

    useEffect(() => {
        document.addEventListener('click', handleOutSideclick1);
        return () => {
            document.removeEventListener('click', handleOutSideclick1);
        }
    }, [trackAnalysisExperts?.expertIntroduction?.value, showText]);

    const onClickDisclaimer = () => { 
        setshowDisclaimer(true);
        handleWA("Disclaimer")
    }

    const handleWA = ( type: string) => { 

        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: `racing/simulcast_Click_TrackAnalysis-Expert_${type}`,
            country: myContextState.selectedMeeting?.countryNameEn || '',
            author: expertNameEn, 
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });  
    }

    const handleOutSideclick = useCallback((event: any) => {
        if(!showDisclaimer) return
        
        const targetDiv = document.querySelector('.hidden-disclaimer');
        const rect = targetDiv?.getBoundingClientRect() || {} as any;
        const isInside =
            event?.clientX >= rect?.left &&
            event?.clientX <= rect?.right &&
            event?.clientY >= rect?.top &&
            event?.clientY <= rect?.bottom;
        if (!isInside) {
            setshowDisclaimer(false)
        }
    }, [showDisclaimer]) 

    const handleOutSideclick1 = useCallback((event: any) => {
        if(!showText) return
        
        const targetDiv = document.querySelector('.hidden-text');
        const rect = targetDiv?.getBoundingClientRect() || {} as any;
        const isInside =
            event?.clientX >= rect?.left &&
            event?.clientX <= rect?.right &&
            event?.clientY >= rect?.top &&
            event?.clientY <= rect?.bottom;
        if (!isInside) {
            setshowText(false)
        }
    }, [showText])

    const handleVideoClose = () => {
        setIsShowVideoPlay(false);
        setWAData(undefined);
        setVideoSources([])
    }

    const openVideoPlayer = (validVideo: ValidVideo, url: any, waContentTitle?: string) => {
        if (!validVideo.hasVideo()) return;
        setWAData({
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
            contentTitle: waContentTitle,
        });
        setVideoSources(generateVideoSource(url.sd, url.hd));
        setIsShowVideoPlay(true);
    }

    useEffect(() => {
        if (myContextState.isLoadingRaces) return;
        if (!myContextState.selectedMeeting?.displayName) {
            setRacesDetailLoading(props.setRacesDetailLoading)
            completeLoading('page');
            return
        }
        resetVideoPlayer();
        getTrackAnalysis(lang.langCode, myContextState.season, myContextState.selectedMeeting?.displayName)
            .then(async (res: any) => {
                if (res?.item) {
                    
                    // for dev
                    // const videoUrl = [{"quality":"sd", "url":"http://localhost/video/v.mp4"},{"quality":"hd", "url":"http://localhost/video/v.mp4"}];
                    // const videoUrl = { "sd": "http://localhost/video/v.mp4", "hd": "http://localhost/video/v.mp4" };
                    
                    const videoUrl = generateVideoUrl(res?.item?.videoLink?.value || "");                               

                    const videoValidation = await validateVideo(videoUrl);

                    const trackAnalysisData = { ...res?.item, videoSources: generateVideoSource(videoUrl?.sd, videoUrl?.hd), videoValidation: videoValidation };
                    setTrackAnalysisData(trackAnalysisData);
                    const expertName = res?.item?.expertSelection?.value || '';

                    if (expertName !== '') {
                        setExpertName(expertName);
                        getTrackAnalysisExperts(lang.langCode, expertName || '')
                            .then((resExperts: any) => {
                                setTrackAnalysisExperts(resExperts?.item);
                                setExpertNameEn(resExperts?.enItem?.expertName?.value || "");
                            })
                            .catch((e: any) => {
                                console.log(e);
                            });
                    }
                } else {
                    setTrackAnalysisData(null);
                }

            })
            .catch((e: any) => {
                console.log(e);
            }).finally(() => {
                setRacesDetailLoading(props.setRacesDetailLoading)
                completeLoading('page');
            });
    }, [myContextState.selectedMeeting, myContextState.isLoadingRaces]);

    useEffect(()=>{
        resetVideoPlayer();
    }, [myContextState.selectedRaceNo])

    const [showInlineVideoPlayer, setShowInlineVideoPlayer] = useState(false);
    const resetVideoPlayer = () => {        
        setWAData(undefined);
        setShowInlineVideoPlayer(false);
    }
    const playVideo = () => {
        setWAData({
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });
        setShowInlineVideoPlayer(true);
    }

    if (!trackAnalysisData)
        return (<>
            <TrackAnalysisHeader id="TrackAnalysis_Header">
                {t('track_analysis')}
            </TrackAnalysisHeader>
            <NoInformation></NoInformation>
        </>)
    //console.log('aaaaaa trackAnalysisData', trackAnalysisData)
    // for dev
    // const showTrackVideo = () => true;
    
    const showTrackVideo = () => trackAnalysisData?.videoThumbnail?.src && trackAnalysisData?.videoLink?.value && trackAnalysisData?.videoValidation?.hasVideo();        
    // MODIFIED: use thumbnail as embedded player preview
    const renderTrackVideoPreviewSlot = () => (
       
        <DivVideo onClick={() => playVideo()}>
            <DivVideoPlayIcon id="trackAnalysis_VideoPlayerIcon_pc">
                <VideoPlayerIcon />
            </DivVideoPlayIcon>

            <div style={{ width: '100%', aspectRatio: "16/9", display: "flex", flexDirection:"column" }}>
                <ImgVideo style={{flex:"1", minHeight: "0",borderRadius:"0px"}} src={trackAnalysisData?.videoThumbnail?.src} alt="" />
                {trackAnalysisData?.videoTitle?.value && (
                    <DivCourseOverview id="trackAnalysis_VideoPlayer_description_pc">
                        {trackAnalysisData?.videoTitle?.value}
                    </DivCourseOverview>
                )}
            </div>
        </DivVideo>
    );

    const renderPlayIcon = () => <img src={`${myContextState.assetPrefix}/videoplayer_play.svg`} width="46px" height="46px" alt="play icon" />

    const expertColumnDialog = () => {
        return (
            <Dialog
                className='expertColumnDialog'
                open={openDialog}
                keepMounted
                fullWidth
                TransitionComponent={Transition}
                sx={{
                    '& .MuiModal-backdrop': {
                        zIndex: 0,
                        position: 'absolute'
                    },
                    '& .MuiDialog-container': {
                        alignItems: 'flex-end',
                        ' .MuiPaper-root': {
                            zIndex: 1
                        }
                    },
                    '& .MuiPaper-root': {
                        maxWidth: 'unset',
                        width: '100%',
                        margin: 0,
                        borderRadius: '12px 12px 0 0',
                    } 
                }}
                onClose={() => { setOpenDialog(false) }}
            >
                <DialogTitle className='dialogTit' id="customized-dialog-title">
                    { dialogType == "disclaimer" ? t("expert_column_disclaimer") : trackAnalysisExperts?.expertName?.value}
                </DialogTitle >
                <IconButton
                    className='dialogClose'
                    aria-label="close"
                    onClick={() => { setOpenDialog(false) }}
                >
                    <CloseIcon />
                </IconButton> 
                <DialogContent className='dialogcontent'>
                    {
                        dialogType == "disclaimer" ? <Disclaimer disclaimerData={disclaimerData} hideTitle={true} fontSize={13} /> :
                        <div dangerouslySetInnerHTML={{ __html: trackAnalysisExperts?.expertIntroduction?.value }}></div>
                    }
                    
                </DialogContent>
            </Dialog>

        )
    }

    return (
        <>
            {props.type === "pc" ?
                (
                    <DivContainer $assetPrefix={myContextState.assetPrefix}>
                        <TrackAnalysisHeader id="TrackAnalysis_Header">
                            {t('track_analysis')}
                        </TrackAnalysisHeader>

                        <div style={{padding: "12px"}}>

                            <TrackAnalysisExpertName>
                                <TrackAnalysisHeaderImg
                                    src={trackAnalysisExperts?.expertPicture?.src}
                                    alt={trackAnalysisExperts?.expertPicture?.alt} />
                                {expertName !== '' ?
                                    <div style={{
                                        alignItems: "center",
                                        "display": "flex"
                                    }}>
                                        <InnerSpan >{trackAnalysisExperts?.expertName?.value}</InnerSpan>
                                    </div>
                                    : null}
                                <TipsContainer>
                                    <div style={{ position: "relative", lineHeight: "10px", cursor: "pointer" }}>
                                        <img src={`${myContextState.assetPrefix}/commonImg/expert_icon.svg`} className="HoverIcon" onClick={() => {
                                            if (showText) return
                                            setshowText(true);
                                            handleWA("Info");
                                        }} />
                                        <TriangleUp $showText={showText} />
                                    </div>
                                </TipsContainer>

                                <Hiddentext className="hidden-text" $showText={showText} dangerouslySetInnerHTML={{ __html: trackAnalysisExperts?.expertIntroduction?.value }}>

                                </Hiddentext>
                            </TrackAnalysisExpertName>

                            {(trackAnalysisData?.title?.value && trackAnalysisData?.description?.value) ?
                                <TopContentWrapper>
                                    <DivTrackAnalysiContent id="trackAnalysis_content_pc">
                                        <DivTitle id="trackAnalysisContent_title_pc">{trackAnalysisData?.title?.value}</DivTitle>
                                        <DivContent id="trackAnalysisContent_content_pc" dangerouslySetInnerHTML={{ __html: trackAnalysisData?.description?.value?.replaceAll("\r\n", "<br/>") ?? '' }}></DivContent>
                                    </DivTrackAnalysiContent>

                                    <DivTrackAndVideo>
                                        {!TwoASwitch && trackAnalysisData?.trackMap?.targetItem?.trackImage?.src ? <ImgTrack id="trackAnalysis_img_pc" src={trackAnalysisData?.trackMap?.targetItem?.trackImage?.src || ''} alt={trackAnalysisData?.trackMap?.targetItem?.trackImage?.alt || ''} /> : <></>}
                                        {showTrackVideo() ?
                                            <VideoPlayer
                                                title={trackAnalysisData?.videoTitle?.value}
                                                sources={trackAnalysisData?.videoSources}
                                                WAData={WAData}
                                                isEmbed
                                                hideTitleBar={true}
                                                isMobile={false}
                                                autoPlay={true}
                                                open={showInlineVideoPlayer}
                                                previewSlot={renderTrackVideoPreviewSlot()}
                                                // Enforce a stable 16:9 inline container
                                                embedWrapperStyle={{
                                                    aspectRatio: "16 / 9",
                                                    width: "100%",
                                                    height: "auto",
                                                }}
                                                customPlayIconSlot={renderPlayIcon()}
                                                defaultPlayrate={1.5}
                                            />
                                            : <></>
                                        }
                                    </DivTrackAndVideo>
                                </TopContentWrapper>
                                : <></>
                            }
                            {/* <DivTopSolid></DivTopSolid> */}
                            <div>
                                {
                                    TwoASwitch &&
                                    <DisclaimerWrapper>
                                        <div>
                                            {t("expert_column_hardcode_msg")}
                                            <span style={{ position: "relative", lineHeight:"24px", minWidth:"94px" }} onClick={(e: any) => {
                                                e.preventDefault();
                                                onClickDisclaimer()
                                            }}>
                                                <img style={{ verticalAlign: "middle",  padding:"2px", paddingRight:"4px"}} src={`${myContextState.assetPrefix}/commonImg/expert_icon.svg`} />
                                                {t("expert_column_disclaimer")}
                                                <TriangleUpDisclaimer $showDisclaimer={showDisclaimer} />
                                                <HiddenDisclaimer className="hidden-disclaimer" $showDisclaimer={showDisclaimer} onClick={(e) => e.stopPropagation()}>
                                                    <Disclaimer hideTitle={true} fontSize={13} />
                                                </HiddenDisclaimer>
                                            </span>
                                        </div>
                                    </DisclaimerWrapper>
                                }
                            </div>
                        </div>
                    </DivContainer>
                ) : (
                    <DivContainerM>
                        {(trackAnalysisData?.title?.value && trackAnalysisData?.description?.value) ?
                            <>
                                {showTrackVideo() ?
                                    <VideoPlayer
                                        title={trackAnalysisData?.videoTitle?.value}
                                        sources= {trackAnalysisData?.videoSources}
                                        WAData={WAData}
                                        isEmbed
                                        hideTitleBar = {true}
                                        isMobile={true}
                                        autoPlay={true}
                                        open={showInlineVideoPlayer}
                                        previewSlot={!showInlineVideoPlayer ? renderTrackVideoPreviewSlot() : undefined}
                                        embedWrapperStyle={{
                                            aspectRatio: "16 / 9",
                                        }}
                                        customPlayIconSlot={renderPlayIcon()}
                                        height="100%"
                                        defaultPlayrate={1.5}
                                    />                                         
                                    : <></>
                                }                                  
                                <DivTitle id="trackAnalysis_title_mobile">{trackAnalysisData?.title?.value}</DivTitle>
                                {!TwoASwitch && trackAnalysisData?.trackMap?.targetItem?.trackImage?.src ? <ImgTrackM id="trackAnalysis_img_mobile" src={trackAnalysisData?.trackMap?.targetItem?.trackImage?.src || ''} alt={trackAnalysisData?.trackMap?.targetItem?.trackImage?.alt || ''} /> : <></>}
                                <DivContent id="trackAnalysis_content_mobile" dangerouslySetInnerHTML={{ __html: trackAnalysisData?.description?.value?.replaceAll("\r\n", "<br/>") ?? '' }}></DivContent>

                            </>
                            : <></>
                        }
                        {/* {expertName !== '' ? <ExpertProfile type="mobile" expertName={expertName}></ExpertProfile> : <></>} */}
                        {
                            <TrackAnalysisExpertNameM>
                                <p className='pic'>
                                    <img src={trackAnalysisExperts?.expertPicture?.src} alt={trackAnalysisExperts?.expertPicture?.alt} />
                                </p>
                                {
                                    expertName ?
                                        <>
                                            {trackAnalysisExperts?.expertName?.value}
                                            <i className='info-icon' 
                                                onClick={() => {
                                                    handleWA("Info"); 
                                                    setDialogType("Info");
                                                    setOpenDialog(true);
                                                    }}>
                                                <img src={`${myContextState.assetPrefix}/commonImg/expert_icon.svg`} />
                                            </i>
                                        </> : null
                                }                                
                            </TrackAnalysisExpertNameM>
                        }
                        { TwoASwitch &&
                            <DisclaimerWrapperM>
                                <div style={{height:"28px", lineHeight:"14px"}}>{t("expert_column_hardcode_msg")}</div>
                                <p onClick={() => { onClickDisclaimer(); setOpenDialog(true); setDialogType("disclaimer");}}>
                                    <img src={`${myContextState.assetPrefix}/commonImg/expert_icon.svg`} />
                                    {t("expert_column_disclaimer")}
                                </p>
                            </DisclaimerWrapperM>                            
                        }
                        {expertColumnDialog()}
                    </DivContainerM>
                )
            }
            <VideoPlayer WAData={WAData} sources={videoSources} open={isShowVideoPlay} isMobile={isMobile} handleClose={handleVideoClose} width={isMobile ? undefined : '60%'} height={isMobile ? undefined : '60%'} showCurrentTooltip showHoveredTooltip autoPlay />
        </>
    )
}

export default TrackAnalysis; 